import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import StickyArrowLayerContainer from './ArrowLayer/StickyArrowLayerContainer';
import StickyMouseTooltip from './StickyMouseTooltip/StickyMouseTooltip';
import withIntl from '../../lib/withIntl';
import {ProtocolEditorViewMode} from '../../constants/dataEnum';

function StickyMouseComponents({
  selectedCard,
  tooltipVisible,
  initMousePosition,
  intl,
  tooltipMessage,
  protocolEditorMode,
}) {
  const [mousePosition, setMousePosition] = useState({x: null, y: null});
  const [isArrowShowing, setIsArrowShowing] = useState(false);

  useEffect(() => {
    const updateMousePosition = (ev) => {
      setMousePosition({x: ev.clientX, y: ev.clientY});
    };

    if (
      protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
      protocolEditorMode === ProtocolEditorViewMode.POOLING
    ) {
      window.addEventListener('mousemove', updateMousePosition);
    }

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, [isArrowShowing, protocolEditorMode]);

  useEffect(() => {
    if ('x' in initMousePosition) {
      setMousePosition(initMousePosition);
    }
  }, [initMousePosition]);

  return (
    <>
      <StickyArrowLayerContainer
        selectedCard={selectedCard}
        isArrowSticky={
          protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
          protocolEditorMode === ProtocolEditorViewMode.POOLING
        }
        isArrowShowing={isArrowShowing}
        setIsArrowShowing={setIsArrowShowing}
        mousePosition={mousePosition}
      />
      <StickyMouseTooltip mousePosition={mousePosition} visible={tooltipVisible}>
        {intl.formatMessage({
          id: tooltipMessage,
        })}
      </StickyMouseTooltip>
    </>
  );
}

StickyMouseComponents.propTypes = {
  selectedCard: PropTypes.object,
  tooltipVisible: PropTypes.bool,
  intl: PropTypes.any.isRequired,
  initMousePosition: PropTypes.object,
  tooltipMessage: PropTypes.string.isRequired,
  protocolEditorMode: PropTypes.string,
};

StickyMouseComponents.defaultProps = {
  selectedCard: {},
  tooltipVisible: false,
  initMousePosition: {},
  protocolEditorMode: null,
};

function areEqual(prevProps, nextProps) {
  return (
    _.isEqual(prevProps.selectedCard, nextProps.selectedCard) &&
    _.isEqual(prevProps.initMousePosition, nextProps.initMousePosition) &&
    prevProps.tooltipVisible === nextProps.tooltipVisible &&
    prevProps.tooltipMessage === nextProps.tooltipMessage &&
    prevProps.protocolEditorMode === nextProps.protocolEditorMode
  );
}

export default React.memo(withIntl(StickyMouseComponents), areEqual);
